import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const ProjectsSort = ({ value, onChange }) => {
  return (
    <FormControl size="small" className="projectsSortControl">
      <InputLabel id="projects-sort-label">Sort by</InputLabel>
      <Select labelId="projects-sort-label" value={value} label="Sort by" onChange={(e) => onChange?.(e.target.value)}>
        <MenuItem value="lastModified">Last Modified</MenuItem>
        <MenuItem value="projectName">Project name</MenuItem>
        <MenuItem value="createdAt">Created At</MenuItem>
        <MenuItem value="status">Status</MenuItem>
        <MenuItem value="numberOfCalculations"># Calculations</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ProjectsSort;
